<template>
<div>
  <track-m :id="id" class="display-mobile"></track-m>
  <track-pc :id="id" class="display-pc"></track-pc>
</div>
</template>

<script>
import TrackPc from './track-pc'
import TrackM from './track-m'
// import Speaker from '../com-speaker'
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  components: {
    TrackM,
    TrackPc
    // Speaker
  },
  props: [
    'id'
  ],
  computed: {
    track () {
      return this.$store.state.topics[this.id] || { lectureIds: [] }
    },
    presentations () {
      return this.track.lectureIds.map(id => this.$store.state.lectures[id])
    },
    speakerConfig () {
      return this.$store.state.speakerConfig
    },
    presentationTime () {
      return moment(this.track.time).utcOffset('+08:00').format('MM月DD日 hh:mm')
    }
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass"></style>
